export const allowedRoles = {
	Director_de_Informática: 'Director_de_Informática',
	Director_de_Bienes_Fiscales: 'Director_de_Bienes_Fiscales',
	Operador_de_Dirección_de_Bienes_Fiscales: 'Operador_de_Dirección_de_Bienes_Fiscales',
	Encargado_Patrimonial: 'Encargado_Patrimonial',
	Operador_Dependencia_Patrimonial: 'Operador_de_Dependencia_Patrimonial',
	Super_Admin: 'Super_Admin'
};
